import {Fragment, useEffect, useState} from "react";
import {
    Autocomplete, Box,
    Checkbox,
    FormControl,
    FormControlLabel,
    FormLabel,
    Grid,
    InputAdornment, MenuItem, Select,
    TextField, Typography
} from "@mui/material";
import {makeStyles} from "@mui/styles";
import {getCountryCode} from "../../Utils/Helper";

const boxSizeList = [
    {
        name: "Small Moving Box",
        length: 16,    // (inches)
        width: 12,
        height: 12,
        weight: 50     // max weight capacity (lbs)
    },
    {
        name: "Medium Moving Box",
        length: 18,
        width: 16,
        height: 12,
        weight: 65
    },
    {
        name: "Large Moving Box",
        length: 24,
        width: 18,
        height: 16,
        weight: 80
    },
    {
        name: "Extra-Large Box",
        length: 24,
        width: 18,
        height: 24,
        weight: 100
    },
]

const expectedMovingTimeframe = [
    "Immediately (ASAP)",
    "Within 1 week",
    "Within 2 weeks",
    "Within 1 month",
    "Within 2-3 months",
    "In 3-6 months",
    "In 6+ months",
    "Flexible / Not sure yet"
]

const useStyles = makeStyles({
    smallInput: {
        "& .MuiInputBase-input": {
            height: "0px", // Adjust the height as per your preference
            padding: "2px", // Adjust the padding as per your preference
            fontSize: "14px", // Adjust the font size as per your preference
        }
    }
});

export const WordPressQuoteMovingItems = ({
                                              cbHandleShippingDetails,
                                              validatedResult,
                                              lng,
                                              cbHandleMovingDate,
                                              cbHandleMovingSkid,
                                              cbHandleSkidList,
                                              cbHandleMovingType,
                                              movingType,
                                              cbHandleResidenceDetails
                                          }) => {

    const classes = useStyles();

    const [askMessage, setAskMessage] = useState({
        role: 'user',
        content: ''
    });
    const [boxDetail, setBoxDetail] = useState({
        boxSize: {
            name: 'Medium Moving Box'
        },
        length: "18",
        width: "16",
        height: "12",
        weight: "65",
        lengthUnit: 'in',
        weightUnit: 'lb',
        quantity: "1"
    });
    const [skidDetail, setSkidDetail] = useState({
        description: "skid",
        length: "48",
        width: "40",
        height: "80",
        weight: "600",
        quantity: "1"
    });

    const [residenceDetails, setResidenceDetails] = useState({
        numberOfBedRooms: 1,
        numberOfLivingRooms: 1,
    });

    const handleMovingTypeChange = value => {
        cbHandleMovingType(value);
    }

    const handleMovingDescription = (event) => {
        setAskMessage(prevState => ({
            ...prevState,
            content: event?.target?.value
        }));
    }

    const handleBoxSize = (event, value) => {
        setBoxDetail(prevState => ({
            ...prevState,
            boxSize: {
                ...prevState?.boxSize,
                name: value?.name
            },
            length: value?.length,
            width: value?.width,
            height: value?.height,
            weight: value?.weight
        }))
    }

    const handleWeight = event => {
        const {value} = event.target;
        if (/^\d*\.?\d*$/.test(value)) {
            setBoxDetail(prevState => ({
                ...prevState,
                weight: value
            }))
        }
    }

    const handleQuantity = event => {
        const {value} = event.target;
        if (/^\d*\.?\d*$/.test(value)) {
            if (movingType === 4) {
                setBoxDetail(prevState => ({
                    ...prevState,
                    quantity: value
                }));
            } else {
                setSkidDetail(prevState => ({
                    ...prevState,
                    quantity: value
                }));
            }
        }
    }

    const handleQuantityBlur = event => {
        const {value} = event.target;
        if (/^\d*\.?\d*$/.test(value)) {
            if (movingType === 2) {
                if (+value < 1) {
                    setSkidDetail(prevState => ({
                        ...prevState,
                        quantity: "1"
                    }));
                }
                if (+value > 10) {
                    setSkidDetail(prevState => ({
                        ...prevState,
                        quantity: "10"
                    }));
                }
            }
        }
    }

    const handleLength = event => {
        const {value} = event.target;
        if (/^\d*\.?\d*$/.test(value)) {
            setBoxDetail(prevState => ({
                ...prevState,
                length: value
            }))
        }
    }

    const handleWidth = event => {
        const {value} = event.target;
        if (/^\d*\.?\d*$/.test(value)) {
            setBoxDetail(prevState => ({
                ...prevState,
                width: value
            }))
        }
    }

    const handleHeight = event => {
        const {value} = event.target;
        if (/^\d*\.?\d*$/.test(value)) {
            setBoxDetail(prevState => ({
                ...prevState,
                height: value
            }))
        }
    }

    const handleResidenceQuantity = (field, value) => {
        if (/^([1-9]\d*)?$/.test(value)) {
            setResidenceDetails(prevState => ({
                ...prevState,
                [field]: value
            }))
        }
    }

    const handleResidenceQuantityBlur = (field, value) => {
        if (/^([1-9]\d*)?$/.test(value)) {
            if (+value < 1) {
                setResidenceDetails(prevState => ({
                    ...prevState,
                    [field]: "1"
                }))
            }
        }
    }

    useEffect(() => {
        if (movingType === 3) {
            cbHandleShippingDetails(askMessage);
        }
    }, [askMessage, movingType]);

    useEffect(() => {
        if (movingType === 4) {
            cbHandleShippingDetails(boxDetail);
        }
    }, [boxDetail, movingType]);

    useEffect(() => {
        if (movingType === 2) {
            cbHandleSkidList(skidDetail);
        }
    }, [skidDetail, movingType]);

    useEffect(() => {
        if (movingType === 1) {
            cbHandleResidenceDetails(residenceDetails);
        }
    }, [residenceDetails, movingType]);

    // console.log('[WordPressQuoteMovingItems] box detail', boxDetail);
    // console.log('[WordPressQuoteMovingItems] residence detail', residenceDetails);

    return (
        <Fragment>
            <Grid size={{xs: 12, md: 3}}>
                <FormControl fullWidth>
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={movingType === 1}
                                onChange={() => handleMovingTypeChange(1)}
                                style={{
                                    color: 'green',
                                    '&.Mui-checked': {
                                        color: 'green',
                                    }
                                }}
                            />
                        }
                        label={
                            <>
                                {lng === 'cn' ? '居室搬家' : "Full Residence Move"}
                            </>
                        }
                    />
                </FormControl>
            </Grid>
            <Grid size={{xs: 12, md: 3}}>
                <FormControl fullWidth>
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={movingType === 2}
                                onChange={() => handleMovingTypeChange(2)}
                                style={{
                                    color: 'green',
                                    '&.Mui-checked': {
                                        color: 'green',
                                    }
                                }}
                            />
                        }
                        label={
                            <>
                                {lng === 'cn' ? '托盘预留' : "Skid Reservation"}
                            </>
                        }
                    />
                </FormControl>
            </Grid>
            <Grid size={{xs: 12, md: 3}}>
                <FormControl fullWidth>
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={movingType === 3}
                                onChange={() => handleMovingTypeChange(3)}
                                style={{
                                    color: 'green',
                                    '&.Mui-checked': {
                                        color: 'green',
                                    }
                                }}
                            />
                        }
                        label={
                            <>
                                {lng === 'cn' ? '提供物品清单' : "Inventory-Based Move"}
                            </>
                        }
                    />
                </FormControl>
            </Grid>
            <Grid size={{xs: 12, md: 3}}>
                <FormControl fullWidth>
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={movingType === 4}
                                onChange={() => handleMovingTypeChange(4)}
                                style={{
                                    color: 'green',
                                    '&.Mui-checked': {
                                        color: 'green',
                                    }
                                }}
                            />
                        }
                        label={
                            <>
                                {lng === 'cn' ? '只搬运重箱' : "Heavy Box/Parcel Only"}
                            </>
                        }
                    />
                </FormControl>
            </Grid>
            {
                movingType === 4 ?
                    <>
                        <Grid size={{xs: 12, md: 4}}>
                            <FormControl fullWidth>
                                <FormLabel required>
                                    {lng === 'cn' ? '箱子尺寸' : "Box Size"}
                                </FormLabel>
                                <Autocomplete
                                    value={boxDetail?.boxSize}
                                    fullWidth
                                    options={boxSizeList}
                                    getOptionLabel={option => option.name}
                                    onChange={handleBoxSize}
                                    renderInput={(params) => <TextField
                                        variant="outlined"
                                        {...params}
                                        className={classes.smallInput}
                                        error={validatedResult !== null && !boxDetail?.boxSize?.name}
                                        helperText={(validatedResult !== null && !boxDetail?.boxSize?.name) && (lng === 'cn' ? "必填" : "Required")}
                                    />}
                                    renderOption={(props, option) => (
                                        <li {...props}>
                                            <Typography style={{fontSize: '12px'}}>
                                                {option?.name}
                                            </Typography>
                                        </li>
                                    )}
                                />
                            </FormControl>
                        </Grid>
                        <Grid size={{xs: 12, md: 4}}>
                            <FormControl fullWidth>
                                <FormLabel required>
                                    {lng === 'cn' ? '数量' : "Quantity"}
                                </FormLabel>
                                <TextField
                                    value={boxDetail?.quantity}
                                    onInput={handleQuantity}
                                    fullWidth
                                    variant='outlined'
                                    type='number'
                                    size='small'
                                    sx={{
                                        '& .MuiInputBase-root': {  // Targets the root input container
                                            height: 33,  // Set custom height (default small is ~36px)
                                            fontSize: '14px',  // Consistent font size
                                        },
                                    }}
                                    error={validatedResult !== null && (+boxDetail?.quantity <= 0 || !boxDetail?.quantity)}
                                    helperText={validatedResult !== null && (!boxDetail?.quantity ? (lng === 'cn' ? "必填" : "Required") : +boxDetail?.quantity <= 0 && (lng === 'cn' ? "无效" : "Invalid"))}
                                />
                            </FormControl>
                        </Grid>
                        <Grid size={{xs: 12, md: 4}}>
                            <FormControl fullWidth>
                                <FormLabel required>
                                    {lng === 'cn' ? '重量' : "Weight"}
                                </FormLabel>
                                <TextField
                                    value={boxDetail?.weight}
                                    onInput={handleWeight}
                                    fullWidth
                                    variant='outlined'
                                    type='number'
                                    size='small'
                                    sx={{
                                        '& .MuiInputBase-root': {  // Targets the root input container
                                            height: 33,  // Set custom height (default small is ~36px)
                                            fontSize: '14px',  // Consistent font size
                                        },
                                    }}
                                    slotProps={{
                                        input: {
                                            endAdornment: <InputAdornment position="end">
                                                {boxDetail?.weightUnit}
                                            </InputAdornment>,
                                        },
                                    }}
                                    error={validatedResult !== null && (+boxDetail?.weight <= 0 || !boxDetail?.weight)}
                                    helperText={validatedResult !== null && (!boxDetail?.weight ? (lng === 'cn' ? "必填" : "Required") : +boxDetail?.weight <= 0 && (lng === 'cn' ? "无效" : "Invalid"))}
                                />
                            </FormControl>
                        </Grid>
                        <Grid size={{xs: 12, md: 4}}>
                            <FormControl fullWidth>
                                <FormLabel required>
                                    {lng === 'cn' ? '长' : "Length"}
                                </FormLabel>
                                <TextField
                                    value={boxDetail?.length}
                                    onInput={handleLength}
                                    fullWidth
                                    variant='outlined'
                                    type='number'
                                    size='small'
                                    sx={{
                                        '& .MuiInputBase-root': {  // Targets the root input container
                                            height: 33,  // Set custom height (default small is ~36px)
                                            fontSize: '14px',  // Consistent font size
                                        },
                                    }}
                                    slotProps={{
                                        input: {
                                            endAdornment: <InputAdornment position="end">
                                                {boxDetail?.lengthUnit}
                                            </InputAdornment>,
                                        },
                                    }}
                                    error={validatedResult !== null && (+boxDetail?.length <= 0 || !boxDetail?.length)}
                                    helperText={validatedResult !== null && (!boxDetail?.length ? (lng === 'cn' ? "必填" : "Required") : +boxDetail?.length <= 0 && (lng === 'cn' ? "无效" : "Invalid"))}
                                />
                            </FormControl>
                        </Grid>
                        <Grid size={{xs: 12, md: 4}}>
                            <FormControl fullWidth>
                                <FormLabel required>
                                    {lng === 'cn' ? '宽' : "Width"}
                                </FormLabel>
                                <TextField
                                    value={boxDetail?.width}
                                    onInput={handleWidth}
                                    fullWidth
                                    variant='outlined'
                                    type='number'
                                    size='small'
                                    sx={{
                                        '& .MuiInputBase-root': {  // Targets the root input container
                                            height: 33,  // Set custom height (default small is ~36px)
                                            fontSize: '14px',  // Consistent font size
                                        },
                                    }}
                                    slotProps={{
                                        input: {
                                            endAdornment: <InputAdornment position="end">
                                                {boxDetail?.lengthUnit}
                                            </InputAdornment>,
                                        },
                                    }}
                                    error={validatedResult !== null && (+boxDetail?.width <= 0 || !boxDetail?.width)}
                                    helperText={validatedResult !== null && (!boxDetail?.width ? (lng === 'cn' ? "必填" : "Required") : +boxDetail?.width <= 0 && (lng === 'cn' ? "无效" : "Invalid"))}
                                />
                            </FormControl>
                        </Grid>
                        <Grid size={{xs: 12, md: 4}}>
                            <FormControl fullWidth>
                                <FormLabel required>
                                    {lng === 'cn' ? '高' : "Height"}
                                </FormLabel>
                                <TextField
                                    value={boxDetail?.height}
                                    onInput={handleHeight}
                                    fullWidth
                                    variant='outlined'
                                    type='number'
                                    size='small'
                                    sx={{
                                        '& .MuiInputBase-root': {  // Targets the root input container
                                            height: 33,  // Set custom height (default small is ~36px)
                                            fontSize: '14px',  // Consistent font size
                                        },
                                    }}
                                    slotProps={{
                                        input: {
                                            endAdornment: <InputAdornment position="end">
                                                {boxDetail?.lengthUnit}
                                            </InputAdornment>,
                                        },
                                    }}
                                    error={validatedResult !== null && (+boxDetail?.height <= 0 || !boxDetail?.height)}
                                    helperText={validatedResult !== null && (!boxDetail?.height ? (lng === 'cn' ? "必填" : "Required") : +boxDetail?.height <= 0 && (lng === 'cn' ? "无效" : "Invalid"))}
                                />
                            </FormControl>
                        </Grid>
                    </>
                    :
                    movingType === 2 ?
                        <>
                            <Grid size={{xs: 12, md: 8}}>
                                <FormControl fullWidth>
                                    <FormLabel required>
                                        {lng === 'cn' ? '托盘规格' : "Skid Specifications"}
                                    </FormLabel>
                                    <TextField
                                        value={`${skidDetail?.description}, ${skidDetail?.length}x${skidDetail?.width}x${skidDetail?.height} in, ${skidDetail?.weight} lb`}
                                        disabled={true}
                                        fullWidth
                                        variant='outlined'
                                        size='small'
                                        sx={{
                                            '& .MuiInputBase-root': {  // Targets the root input container
                                                height: 33,  // Set custom height (default small is ~36px)
                                                fontSize: '14px',  // Consistent font size
                                            },
                                        }}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid size={{xs: 12, md: 4}}>
                                <FormControl fullWidth>
                                    <FormLabel required>
                                        {lng === 'cn' ? '数量' : "Quantity"}
                                    </FormLabel>
                                    <TextField
                                        value={skidDetail?.quantity}
                                        onInput={handleQuantity}
                                        onBlur={handleQuantityBlur}
                                        fullWidth
                                        variant='outlined'
                                        type='number'
                                        size='small'
                                        sx={{
                                            '& .MuiInputBase-root': {  // Targets the root input container
                                                height: 33,  // Set custom height (default small is ~36px)
                                                fontSize: '14px',  // Consistent font size
                                            },
                                        }}
                                        helperText={lng === 'cn'
                                            ? "• 数量限制：1-10 托 (不可为小数)"
                                            : "• Limit: 1-10 skids (No fractions)"}
                                    />
                                </FormControl>
                            </Grid>
                        </>
                        :
                        movingType === 3 ?
                            <Grid size={{xs: 12}}>
                                <FormControl fullWidth>
                                    <FormLabel required sx={{textAlign: 'left'}}>
                                        {lng === 'cn' ? '简单填写搬运的物品' : "Simply enter what you want to move"}
                                    </FormLabel>
                                    <TextField
                                        sx={{
                                            '& .MuiInputBase-root': {  // Targets the root input container
                                                // height: 33,  // Set custom height (default small is ~36px)
                                                fontSize: '14px',  // Consistent font size
                                            },
                                        }}
                                        value={askMessage?.content}
                                        onInput={handleMovingDescription}
                                        fullWidth
                                        multiline
                                        rows={5}
                                        variant="outlined"
                                        size='small'
                                        error={validatedResult !== null && !askMessage?.content?.trim()}
                                        helperText={
                                            validatedResult !== null && !askMessage?.content?.trim()
                                                ? (lng === 'cn' ? "必填" : "Required")
                                                : `${askMessage?.content?.length || 0}/800`
                                        }
                                        placeholder={lng === 'cn' ? "请按'品名:数量'格式列明（例如：沙发:1，餐桌:1，椅子:4，电视:2，灯具:3）" : "List items with quantities, e.g., Sofa:1, Dining Table:1, Chair:4, TV:2, Lamp:3"}
                                        inputProps={{maxLength: 800}}
                                    />
                                </FormControl>
                            </Grid>
                            :
                            <>
                                <Grid size={{xs: 12, md: 6}}>
                                    <FormControl fullWidth>
                                        <FormLabel required>
                                            {lng === 'cn' ? '卧室数量' : "Bed Room Quantity"}
                                        </FormLabel>
                                        <TextField
                                            value={residenceDetails?.numberOfBedRooms}
                                            onInput={(event) => handleResidenceQuantity('numberOfBedRooms', event.target.value)}
                                            onBlur={(event) => handleResidenceQuantityBlur('numberOfBedRooms', event.target.value)}
                                            fullWidth
                                            variant='outlined'
                                            type='number'
                                            size='small'
                                            sx={{
                                                '& .MuiInputBase-root': {  // Targets the root input container
                                                    height: 33,  // Set custom height (default small is ~36px)
                                                    fontSize: '14px',  // Consistent font size
                                                },
                                            }}
                                        />
                                    </FormControl>
                                </Grid>
                                <Grid size={{xs: 12, md: 6}}>
                                    <FormControl fullWidth>
                                        <FormLabel>
                                            {lng === 'cn' ? '起居室数量' : "Living Room Quantity"}
                                        </FormLabel>
                                        <TextField
                                            value={residenceDetails?.numberOfLivingRooms}
                                            onInput={(event) => handleResidenceQuantity('numberOfLivingRooms', event.target.value)}
                                            // onBlur={(event) => handleResidenceQuantityBlur('numberOfLivingRoom', event.target.value)}
                                            fullWidth
                                            variant='outlined'
                                            type='number'
                                            size='small'
                                            sx={{
                                                '& .MuiInputBase-root': {  // Targets the root input container
                                                    height: 33,  // Set custom height (default small is ~36px)
                                                    fontSize: '14px',  // Consistent font size
                                                },
                                            }}
                                        />
                                    </FormControl>
                                </Grid>
                            </>
            }
        </Fragment>
    )
}
